export const handleEmailClick = (email) => {
  window.location.href = `mailto:${email}`;
};
